export default class Wysiwyg {
	constructor(elm) {
        this.elm = elm;

        this.buttons = this.elm.querySelectorAll('.c-btn');
        if(this.buttons) {
            this.createButtonMarkup();
        }

        this.links = this.elm.querySelectorAll('.c-link');
        if(this.buttons) {
            this.createLinkMarkup();
        }
	}

	createButtonMarkup() {
        this.buttons.forEach(button => {
            const content = button.innerHTML;
            button.innerHTML = '';

            const bg = document.createElement('span');
            bg.setAttribute('class', 'c-btn__bg');
            button.appendChild(bg);

            const text = document.createElement('span');
            text.setAttribute('class', 'c-btn__text');
            text.textContent = content;
            button.appendChild(text);
        });

    }

    createLinkMarkup() {
        this.links.forEach(link => {
			const content = link.innerHTML;
            link.innerHTML = '';

            const text = document.createElement('span');
            text.setAttribute('class', 'c-link__text');
            text.textContent = content;
            link.appendChild(text);
		});
    }
}
